module.exports = __webpack_public_path__ + "static/GrandirsansPalir-MaiJuin2022-Scotomalab-c92d1a9dd1ef35e64675871ee69ed363.pdf";